import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';
import cx from 'classnames';
import { Skeleton } from '@material-ui/lab';

import { TruncatedTooltip } from 'src/components/TruncatedTooltip';
import { IconUpload } from 'src/assets/icons/Upload';
import { VIEW_TYPE } from '../../const';
import { useViewState } from './useViewState';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const NavigationBarItems = ({ className }) => {
  const styles = useStyles();

  const { activeView, projectData } = useViewState();
  const haveProjectData = projectData != null;
  const projectName = projectData?.name;

  const { handleShareClick, handleLoginClick } = useHandlers();

  return (
    <div
      className={cx('flex items-center flex-1', className)}
      data-testid="NavigationBarItems"
    >
      {activeView === VIEW_TYPE.loading && (
        <Skeleton
          className="ml-1 bg-neutral-gray"
          variant="text"
          width={250}
        />
      )}

      {activeView === VIEW_TYPE.project && (
        <TruncatedTooltip title={projectName}>
          {(labelRef) => (
            <Typography
              className={styles.labelName}
              ref={labelRef}
              data-testid="NavigationBarItems__ProjectName"
            >
              {projectName}
            </Typography>
          )}
        </TruncatedTooltip>
      )}

      <div className="flex-1" />

      <Button
        className="min-w-[82px] h-[30px] rounded-md"
        onClick={handleShareClick}
        startIcon={<IconUpload />}
        disabled={!haveProjectData}
        variant="contained"
        color="primary"
      >
        Share
      </Button>
      <Button
        className={cx(
          'min-w-[82px] h-[30px] ml-1.5',
          'rounded-md',
          'text-primary-light bg-neutral-darkGray'
        )}
        onClick={handleLoginClick}
        variant="contained"
        color="default"
      >
        Log in
      </Button>
    </div>
  );
};

NavigationBarItems.propTypes = {
  className: PropTypes.string,
};
NavigationBarItems.defaultProps = {
  className: '',
};
